import {enumType} from 'common/enumType';

export const ReportType = enumType({
   AUDIT_DETAIL: 'Audit Detail',
   AUDIT_SUMMARY: 'Audit Summary',
   OPENPGP_KEYS: 'OpenPGP Keys',
   PARTNERS: 'Partners',
   SSH_KEYS: 'SSH Client Keys',
   SSL_CERTS: 'SSL Certificates',
   TRANSACTIONS: 'Transactions',
   USER_ACTIVITY: 'User Activity',
   SFTP_USERS: 'File Transfer Users',
   SFTP_ACTIVITY: 'File Transfer Activity',
   IPACCESS_RULES: 'IP Access Rules',
   ADMIN_PERMISSIONS: 'Admin Permissions',
   SFTP_CONNECTIONS: 'File Transfer Connections',
});
